import { useState } from "react";

export const Checkbox = props => {
  const defaultChecked = props.checkStatus ? props.checkStatus : false;
  const id = props.id;
  const delRow = props.delRow;
  const index = props.index;
  const [isChecked, setIsChecked] = useState(defaultChecked);
  // const handleCheck = () => {
  //   console.log("trigger check");
  //   console.log(isChecked);
  //   delRow(index);
  // };
  return (
    <input
      key={id}
      type="checkbox"
      checked={isChecked}
      onChange={e => {
        setIsChecked(e.target.checked);
        delRow(index);
      }}
    />
  );
};
